<template>
  <div
    class="content"
    id="msCoupon"
  >
    <div class="title">
      <h3>{{$t('ms.siderText')[0].text}} Coupon</h3>
      <div class="title-underline"></div>
    </div>
    <!-- 标签页 -->
    <a-tabs
      default-active-key="0"
      @change="callback"
    >
      <a-tab-pane
        v-for="(item,index) in $t('ms.coupon.tabs')"
        :key="index"
        :tab="item"
      >
        <div
          class="card"
          v-for="listItem in list"
          :key="listItem.id"
        >
          <img
            :src="listItem.detailBannerUrl"
            alt=""
          >
          <div class="card-right">
            <div class="card-info">
              <span class="info-title">{{listItem.merchantName}}</span>
              <span class="info-subTitle">{{listItem.shortDescription}}</span>
              <div class="info-text">
                <span class="info-time">Validity Period：{{listItem.effectiveStartDate | formatDate}} - {{listItem.effectiveEndDate | formatDate}}</span>
              </div>
              <div
                class="card-right-bottom-row"
                v-if="!type"
              >
                <div class="card-payMethod-row">
                  <a
                    class="appleWallet"
                    :href="listItem.addToAppleWalletUrl"
                  >
                    <img
                      src="@/assets/images/wallet.svg"
                      alt=""
                    >
                    {{$t('ms.voucherText.appleWallet')}}
                  </a>
                  <a
                    class="pay"
                    :href="listItem.addToGooglePayUrl"
                  >
                    <img
                      src="@/assets/images/google.svg"
                      alt=""
                    >
                    {{$t('ms.voucherText.pay')}}<span class="verticalLine">|</span>{{$t('ms.voucherText.savePhone')}}
                  </a>
                </div>
              </div>
            </div>
            <button
              :class="['card-btn',type ? '' : 'card-active-btn']"
              :disabled='Boolean(type)'
              @click="showModal(listItem.id)"
            >
              <i class="iconfont icon-love"></i>
              {{$t('ms.coupon.buttons')[index]}}
            </button>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>

    <!-- 二维码框 -->
    <b-modal
      ref="qrModal"
      hide-footer
      hide-header
    >
      <div class="d-block text-center">
        <vue-qr
          :text="qrValue"
          qid="testid"
        ></vue-qr>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import { getMemberCoupons } from '@/api/coupon'
export default {
  data () {
    return {
      list: [],
      type: '',
      // 二维码的值
      qrValue: ''
    }
  },
  methods: {
    callback (key) {
      this.list = []
      switch (key) {
        case 0:
          this.type = ''
          break
        case 1:
          this.type = 'Used'
          break
        case 2:
          this.type = 'Expired'
          break
      }
      this.getCouponsList()
    },
    async getCouponsList () {
      let res
      if (this.type) {
        res = await getMemberCoupons({
          status: this.type
        }).catch(err => {
          if (err.response.status === 401) {
            alert('登錄已過期，請重新登錄')
            // 说明权限不够
            this.$router.push('/')
          }
        })
      } else {
        res = await getMemberCoupons().catch(err => {
          console.log(err.response.status)
          if (err.response.status === 401) {
            // 说明权限不够
            this.$router.push('/')
          }
        })
      }
      this.list = res.list
    },
    // 显示二维码弹出框
    showModal (id) {
      this.$refs['qrModal'].show()
      // 拿到id并保存
      this.qrValue = id
    }
  },
  created () {
    this.getCouponsList()
  },
  filters: {
    formatDate (value) {
      const arr = value.split('-')
      return arr.reverse().join('/')
    }
  },
  components: { VueQr }
}
</script>

<style lang="scss" scoped>
.content {
  padding-bottom: 150px;
  .title {
    margin-bottom: 30px;
    position: relative;
    text-align: left;
    .title-underline {
      content: "";
      position: relative;
      width: 32px;
      height: 5px;
      background-color: #ffbf00;
      border-radius: 3px;
      &::after {
        position: absolute;
        content: "";
        left: 37px;
        width: 5px;
        height: 5px;
        background-color: #ffbf00;
        border-radius: 50%;
      }
    }
  }
}

// 标签页
::v-deep .ant-tabs {
  .ant-tabs-nav-scroll {
    text-align: left;
  }
  .ant-tabs-nav .ant-tabs-tab {
    position: relative;
    margin: 12px 32px 12px 0;
    padding: 0 16px 0 16px;
    border-radius: 30px;
    &:nth-last-child(n + 2)::after {
      content: "";
      position: absolute;
      right: -16px;
      top: 0%;
      height: 100%;
      width: 1px;
      background-color: #cacaca;
    }
  }
  .ant-tabs-tab-active {
    border-bottom: none;
    background-color: #0f96bb;
    color: white;
  }
  .ant-tabs-ink-bar {
    background-color: transparent;
  }
}

// 卡片
.card {
  margin: 20px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 30px 8px;
  border-radius: 3px;
  border: none;
  justify-content: center;
  > img {
    margin: 0 12px;
    width: 112px;
    height: 112px;
    border-radius: 50%;
  }
  .card-right {
    margin: 0 12px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .card-info {
      text-align: left;
      .info-title {
        display: block;
        font-family: Noto Sans CJK TC;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        font-weight: 600;
      }
      .info-subTitle {
        display: block;
        margin-bottom: 10px;
        font-family: Noto Sans CJK TC;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 36px;
        color: #0f96bb;
      }
      .info-text {
        text-align: left;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        color: #b3b3b3;
        .info-time {
          display: block;
        }
        .info-brand {
          display: block;
        }
      }
      .card-right-bottom-row {
        margin-top: 20px;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        button {
          border: none;
          outline: none;
          white-space: nowrap;
          max-height: 30px;
          &:hover {
            opacity: 0.9;
          }
          &:active {
            opacity: 0.8;
          }
        }
        .card-payMethod-row {
          margin-bottom: 10px;
          display: flex;
          flex-wrap: wrap;
          .appleWallet,
          .pay {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 190px;
            height: 30px;
            margin: {
              bottom: 10px;
              right: 15px;
            }
            font-size: 14px;
            color: #000;
            border-radius: 3px;
          }
          .appleWallet {
            color: #fff;
            background-color: #000;
            > img {
              height: 100%;
            }
          }
          .pay {
            border: 1px solid #cdcdcd;
            background-color: #fefefe;
            > img {
              height: 60%;
            }
            > .verticalLine {
              margin: 0 8px;
              color: #ddd;
            }
          }
        }
        .card-searchBtn {
          position: relative;
          padding: 0 15px;
          font-family: Noto Sans TC;
          font-weight: 300;
          font-size: 14px;
          color: #0f96bb;
          border-radius: 3px;
          border: 1px solid #0f96bb;
          background-color: transparent;
          z-index: 1;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 0px;
            height: 100%;
            background-color: #0f96bb;
            z-index: -1;
            transition: all 0.2s;
          }
          &:hover {
            color: #fff;
            &::after {
              width: 100%;
            }
          }
        }
      }
    }
    .card-btn {
      position: relative;
      min-width: 98px;
      height: 28px;
      padding: 0 35px;
      line-height: 28px;
      font-family: Roboto;
      font-size: 14px;
      color: #fff;
      border: none;
      outline: none;
      border-radius: 3px;
      &:disabled {
        cursor: not-allowed;
      }
    }
    .card-btn {
      background: #c5c5c5;
      > .iconfont {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .card-active-btn {
      background: #ffbf00;
    }
  }
}

// 扫码框位置
::v-deep .modal-dialog {
  position: absolute !important;
  margin: 0 !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
</style>